import { render, staticRenderFns } from "./CredentialEdit.vue?vue&type=template&id=849e5fdc&"
import script from "./CredentialEdit.vue?vue&type=script&lang=ts&"
export * from "./CredentialEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialEdit.vue?vue&type=style&index=0&id=849e5fdc&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports